module.exports = __webpack_public_path__ + "static/media/xhs.5aa189f3.svg";